import type { CSSProperties } from "@linaria/core";
import { BORDER_RADIUS_DEFAULT, COLOR_BLACK, COLOR_BLUE_DARK, COLOR_BLUE_LIGHT, COLOR_BLUE_LIGHTER, COLOR_GRAY_DARK, COLOR_GRAY_LIGHT, COLOR_GRAY_LIGHTER, COLOR_GREEN, COLOR_PINK, COLOR_PURPLE, COLOR_RED, COLOR_SHADOW, COLOR_WHITE, COLOR_YELLOW } from "../../constants";
const THEME_VARIABLES: CSSProperties = {
  // stylelint doesn't gracefully handle disabling of
  // lint rules for css-in-js
  // Adding the disable statement for each line does work

  /* stylelint-disable-next-line value-keyword-case */
  "--color-black": COLOR_BLACK,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-white": COLOR_WHITE,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-shadow": COLOR_SHADOW,

  /* stylelint-disable-next-line value-keyword-case */
  "--border-radius-default": BORDER_RADIUS_DEFAULT,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-gray-dark": COLOR_GRAY_DARK,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-gray-light": COLOR_GRAY_LIGHT,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-gray-lighter": COLOR_GRAY_LIGHTER,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-blue-dark": COLOR_BLUE_DARK,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-blue-light": COLOR_BLUE_LIGHT,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-blue-lighter": COLOR_BLUE_LIGHTER,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-green": COLOR_GREEN,

  /* stylelint-disable-next-line value-keyword-case */
  "--color_red": COLOR_RED,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-purple": COLOR_PURPLE,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-yellow": COLOR_YELLOW,

  /* stylelint-disable-next-line value-keyword-case */
  "--color-pink": COLOR_PINK
};

function Theme(props: {
  children: React.ReactNode;
}): JSX.Element {
  return <div style={THEME_VARIABLES}>{props.children}</div>;
}

export default Theme;